import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';

import { getQuestionnaireData } from 'services';
import { Loader } from 'ui';
import QuestionnaireForm from './QuestionnaireForm';

const useStyles = makeStyles(theme => ({
  loader: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));
const useDialogStyles = makeStyles({
  paper: {
    maxWidth: 1300,
  },
});

const Questionnaire = ({ qualificationId }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isPending, setIsPending] = useState(true);
  const [questionsSteps, setQuestionsSteps] = useState([]);
  const classes = useStyles();
  const dialogClasses = useDialogStyles();

  const handleClose = () => setIsModalOpen(false);

  useEffect(() => {
    const fetchData = async () => {
      const questions = await getQuestionnaireData(qualificationId);

      setQuestionsSteps(questions);
      setIsPending(false);
    };

    try {
      fetchData();
    } catch (e) {
      setIsModalOpen(false);
    }
  }, [qualificationId]);

  return (
    <Dialog open={isModalOpen} classes={dialogClasses} fullWidth>
      {isPending ? (
        <Loader classes={classes.loader} center />
      ) : (
        <QuestionnaireForm
          data={questionsSteps}
          qualificationId={qualificationId}
          onClose={handleClose}
        />
      )}
    </Dialog>
  );
};

Questionnaire.propTypes = {
  qualificationId: PropTypes.number.isRequired,
};

export default Questionnaire;
